import { Skeleton } from '@fluentui/react-northstar';

export default function Auth() {
  return (
    <Skeleton content={<div style={{ width: 300, height: 150 }}>&nbps;</div>} />
  );
}
